import { Typography } from 'antd';
import styled from 'styled-components';

import { NeutralColors } from '@/theme';

export const Suffix = styled(Typography.Text)`
  color: ${NeutralColors[60]};
  font-weight: 400;
  margin-left: 4px;
`;
